import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-casemanagement',
  templateUrl: './case-management.component.html',
  styleUrls: ['./case-management.component.scss'],
})
export class CaseManagementComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void { }
}